import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=40a9641b&scoped=true&"
import script from "./Coupons.vue?vue&type=script&lang=ts&"
export * from "./Coupons.vue?vue&type=script&lang=ts&"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=40a9641b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9641b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a9641b')) {
      api.createRecord('40a9641b', component.options)
    } else {
      api.reload('40a9641b', component.options)
    }
    module.hot.accept("./Coupons.vue?vue&type=template&id=40a9641b&scoped=true&", function () {
      api.rerender('40a9641b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Coupons.vue"
export default component.exports